// import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { AllStaffHistoryTableDataColumnType, AllStaffHistoryTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const bookingHistoryTableData = [
    {
        userId: "2a4bb928-7410-4ef0-8bf8-ec2d5ceafd98",
        staffName: "Rashmi Vandna",
        staffId: "SWPST-228",
        staffRole: "Staff",
        staffEmail: "rashmikr56@gmail.com",
        staffPhone: "8326731872",
        counterStatus: "Exit Counter assigned",
    },
    {
        userId: "3b5cc929-8521-4ef1-9cf9-ec3d6ceafd99",
        staffName: "Amit Kumar",
        staffId: "SWPST-229",
        staffRole: "Manager",
        staffEmail: "amitkumar@gmail.com",
        staffPhone: "9876543210",
        counterStatus: "Entry Counter assigned",
    },
];

const handleDelete = async (id: string) => {
  // Your delete logic here (API call, state update, etc.)
  // console.log("Deleting ID:", id);
  try {
    await api.put(`/api/Auth/DeActiveStaffRegistration?userId=${id}`);
    Swal.fire('Cancel!', ' Staff has been deactivated successfully.', 'success');

    // Optional: refresh the list
    // setBookingHistoryTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
  } catch (error) {
    Swal.fire('Error!', 'Failed to deactivate the staff.', 'error');
    console.error("Cancel error:", error);
  }
};

interface ProductListTableActionProps {
    userId: any;
  onDelete: (id: string) => void;
}

export const StaffHistoryTableAction: React.FC<ProductListTableActionProps> = ({ userId, onDelete }) => {

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to active this staff!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Deactivate it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(userId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <button className="btn btn-sm" onClick={handleDeleteClick} title="Deactivate Staff">
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const AllStaffHistoryTableProductName: React.FC<AllStaffHistoryTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const AllStaffHistoryTableStatus :React.FC<AllStaffHistoryTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const staffHistoryTableDataColumn: TableColumn<AllStaffHistoryTableDataColumnType>[] = [
  {
    name: "Name",
    selector: (row) => `${row.staffName}`,
    sortable: true,
  },
  {
    name: "Staff ID",
    cell: (row) =>  <AllStaffHistoryTableStatus title={row.staffId} />,
  },
  {
    name: "Mobile No.",
    cell: (row) =>  <AllStaffHistoryTableStatus title={row.staffPhone} />,
  },
  {
    name: "Email",
    cell: (row) =>  <AllStaffHistoryTableStatus title={row.staffEmail} />,
  },
  {
    name: "Role",
    cell: (row) =>  <AllStaffHistoryTableStatus title={row.staffRole} />,
  },
  {
    name: "Permission",
    cell: (row) =>  <AllStaffHistoryTableStatus title={row.counterStatus} />,
  },
  {
    name: "Action",
    cell: (row) => <StaffHistoryTableAction userId={row.userId} onDelete={handleDelete} />,
  },
];

  export const filtersData = [
    {
      name: "Choose Ticket No.",
      options: ["SWP-4893", "SWP-2311"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "customerMobileNumber",
      options: ["8347821920"],
    },
  ];